<po-page-list
  #poPageList
  p-title="Smart Review"
  [p-actions]="pageActions"
  [p-filter]="filter"
  [p-disclaimer-group]="disclaimerGroup">

  <po-table
    class="sr-reviews-table"
    [p-columns]="columns"
    [p-items]="reviews"
    [p-actions]="tableActions"
    p-actions-right="true"
    p-striped="true"
    p-sort="true"
    [p-loading]="loading"
    [p-show-more-disabled]="allLoaded"
    [p-loading-show-more]="loadingShowMore"
    (p-sort-by)="onSortBy($event)"
    (p-show-more)="onShowMore()"
    (p-change-visible-columns)="onColumnsChange($event)"
    (p-restore-column-manager)="onColumnsRestore()">

    <ng-template p-table-cell-template let-column="column" let-row="row">

      <ng-container *ngIf="column.property === 'resourceType'">
        <po-tag
          [p-value]="getResourceTypeLabel(row)"
          p-color="#753399"
          p-inverse="true">
        </po-tag>
      </ng-container>

      <ng-container *ngIf="column.property === 'sourceProvider'">
        <span *ngIf="getSourceProviderLabel(row.sourceProvider) as provider">{{ provider }}</span>
      </ng-container>

      <ng-container *ngIf="column.property === 'displayName'">
        <div class="sr-label-cell">
          <div class="sr-label-text">
            <span class="sr-primary-label">{{ row.sourceDisplayName || row.resourceId || 'sem nome' }}</span>
            <span class="sr-job-error" *ngIf="getJobError(row)">
              <span class="po-icon po-icon-warning"></span> {{ getJobError(row) }}
            </span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="column.property === 'info'">
        <span class="po-icon po-icon-info sr-info-icon"
          [p-tooltip]="buildTooltip(row)"
          p-tooltip-position="top">
        </span>
      </ng-container>

      <ng-container *ngIf="column.property === 'statusDerived'">
        <div class="sr-status-cell">
          <po-tag
            [p-value]="getStatusLabel(row.statusDerived)"
            [p-type]="getStatusBadgeType(row.statusDerived)"
            p-inverse="true">
          </po-tag>
        </div>
      </ng-container>

      <ng-container *ngIf="column.property === 'currentStep'">
        <po-tag
          [p-value]="getStepLabel(row.currentStep)"
          [p-type]="getStepBadgeType(row.currentStep, row.statusDerived)"
          p-inverse="true">
        </po-tag>
      </ng-container>

      <ng-container *ngIf="column.property === 'requestedAt'">
        <span class="sr-datetime-cell">
          {{ row.requestedAt ? (row.requestedAt | date:'dd/MM/yyyy HH:mm') : 'n/d' }}
        </span>
      </ng-container>

      <ng-container *ngIf="column.property === 'lastActivityAt'">
        <span class="sr-datetime-cell">
          {{ row.lastActivityAt ? (row.lastActivityAt | date:'dd/MM/yyyy HH:mm') : 'n/d' }}
        </span>
      </ng-container>

    </ng-template>

  </po-table>

  <app-send-review-modal
    #sendModal
    (jobSubmitted)="onJobSubmitted($event)">
  </app-send-review-modal>

  <app-retry-job-modal
    #retryModal
    (retryConfirmed)="onRetryConfirmed($event)">
  </app-retry-job-modal>

  <po-modal
    #deleteReviewModal
    [p-title]="pendingDeleteModalTitle"
    p-size="sm"
    [p-primary-action]="deleteReviewPrimaryAction"
    [p-secondary-action]="deleteReviewSecondaryAction"
    p-click-out="false">
    <div class="sr-delete-modal-body">
      <p>
        Você está prestes a excluir o review
        <strong>{{ pendingDeleteDisplayName }}</strong>
        ({{ pendingDeleteResourceTypeLabel }}).
      </p>
      <p>{{ pendingDeleteDescription }}</p>
    </div>
  </po-modal>

  <po-modal
    #deltaReviewModal
    p-title="Revisar novas alterações"
    p-size="sm"
    [p-primary-action]="deltaReviewPrimaryAction"
    [p-secondary-action]="deltaReviewSecondaryAction"
    p-click-out="false">
    <div>
      <p>
        Revisa apenas as novas alterações enviadas desde a última revisão,
        preservando os comentários já feitos nos arquivos que não mudaram.
      </p>
      <p>Se não houver novas alterações, nada será reprocessado.</p>
    </div>
  </po-modal>

</po-page-list>

<!-- Modal de filtros avançados -->
<po-modal
  #advancedFilterModal
  p-title="Busca Avançada"
  p-size="md"
  [p-primary-action]="advancedFilterApplyAction"
  [p-secondary-action]="advancedFilterCancelAction"
  p-click-out="false">

  <div class="po-row">
    <po-multiselect
      class="po-md-6"
      name="advResourceTypes"
      p-label="Tipo"
      p-placeholder="Todos os tipos"
      p-filter-mode="contains"
      [(ngModel)]="advancedFilters.resourceTypes"
      [p-options]="resourceTypeOptions">
    </po-multiselect>
    <po-multiselect
      class="po-md-6"
      name="advSourceProviders"
      p-label="Origem"
      p-placeholder="Todas as origens"
      p-filter-mode="contains"
      [(ngModel)]="advancedFilters.sourceProviders"
      [p-options]="sourceProviderOptions">
    </po-multiselect>
  </div>
  <div class="po-row">
    <po-multiselect
      class="po-md-12"
      name="advStatuses"
      p-label="Status"
      p-placeholder="Todos os status"
      p-filter-mode="contains"
      [(ngModel)]="advancedFilters.statuses"
      [p-options]="statusOptions">
    </po-multiselect>
  </div>
  <div class="po-row">
    <po-input
      class="po-md-12"
      name="advRequestedBy"
      p-label="Solicitado por"
      p-placeholder="Username"
      [(ngModel)]="advancedFilters.requestedBy"
      p-clean>
    </po-input>
  </div>
  <app-period-filter
    presetClass="po-sm-12 po-md-6"
    rangeClass="po-sm-12 po-md-6"
    [period]="advancedFilters.period ?? allPeriod"
    (periodChange)="advancedFilters.period = $event">
  </app-period-filter>

  <ng-container *ngIf="hasComparisonTypeSelected">
    <po-divider p-label="Changeset de comparison"></po-divider>
    <div class="po-row">
      <po-input
        class="po-md-6"
        name="advCompareFrom"
        p-label="Changeset Origem"
        p-placeholder="Ex: 40"
        [(ngModel)]="advancedFilters.compareFrom"
        p-clean>
      </po-input>
      <po-input
        class="po-md-6"
        name="advCompareTo"
        p-label="Changeset Destino"
        p-placeholder="Ex: 42"
        [(ngModel)]="advancedFilters.compareTo"
        p-clean>
      </po-input>
    </div>
  </ng-container>

</po-modal>

<notificationComponentHM></notificationComponentHM>
